import Backgrid from 'backgrid';
import _ from 'lodash';

import DeliveryScheduleImportStatusCell from '@/backgrid/DeliveryScheduleImportStatusCell';
import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import PageableCollection from '@/backbone/PageableCollection';
import { DateCell } from '@/backgrid/MomentCell';


const DeliveryScheduleImportGridView = GridView.extend({
  className: 'delivery-schedule-import-grid',


  initialize() {
    this.options.columns = [
      {
        name: 'fileName',
        label: 'File Name',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        formatter: _.extend({}, Backgrid.CellFormatter.prototype, {
          fromRaw(rawValue, model) {
            //remove uuid from each file when showing on grid
            const parts = rawValue.split(" ");
            const lastWordIndex = parts.findIndex(part => part.endsWith(".csv"));
            if (lastWordIndex >= 2) {
              return `${parts.slice(0, lastWordIndex - 1).join(" ")}.csv`;
            }
            return rawValue;
          }
        }),
      },
      {
        name: 'createdBy',
        label: 'Uploaded By',
        cell: StringCell,
        width: 20,
        headerCell: 'custom',
        editable: false
      },
      {
        name: 'dateCreated',
        label: 'Date Uploaded',
        cell: DateCell,
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: 'status',
        label: 'Status',
        cell: DeliveryScheduleImportStatusCell,
        width: 40,
        headerCell: 'custom',
        editable: false

      },
    ];

    this.options.collection = new PageableCollection(this.options.files);

    this.options.emptyText = 'No Uploads Found';
  },
});

export default DeliveryScheduleImportGridView;
